// react-scroll constants. Used in core-page sub-navigation, content-collapse, and truncated-text
export const SCROLL_DURATION = 300;
export const SCROLL_OFFSET = -60; // pixel height of core-page sub-navigation plus breathing room

// Clears global nav and breadcrumbs on New Core page.
export const GLOBAL_HEADER_OFFSET = -255;
